import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { MyComponent, scrollToTop } from "./Methods";
import NavsList from "./NavsList";
import "../Style/schoolPage.css";
import FullVideo from "./FullVideo";
import { Swiper, SwiperSlide } from 'swiper/react';
import CourseItem from "./CourseItem";
import PagePagintaion from "./PagePagination";
import ImageFullSlider from "./ImageFullSlider";

export default function SchoolPage(){
    const navigate = useNavigate();
    const params = useParams();
    const [isLoading,setIsLoading] = useState(true);
    const [data,setData] = useState({
        title : "",
        isLoading :false,
    });
    const [activeClassType,setActiveClassType] = useState("ftfClass");
    const [showFullDesc,setShowFullDesc] = useState("");
    const [showFullVideo ,setShowFullVideo] = useState(false);
    const [searchParam,] = useSearchParams();
    const pageNumber = useRef(1);
    const teacherCourseSection = useRef(null);
    const [showFullImageSlider ,setShowFullImageSlider] = useState(0);
    useEffect(() => {
        if(!params.id){
            navigate("/");
        }
        scrollToTop();
        fetchData();    
    }, []);
    function fetchData(){
        setTimeout(() => {
            setIsLoading(false);
            setData({
                    title : "آموزشگاه شعبه سعادت اباد",
                    videoLink :"/video/horizontalVideo.mp4",
                    description : `<h3>دوره ی اموزش گیتار کلاسیک</h3><p><span style="color: #ff0000;">محتوای این دوره در محیط المنتور طراحی شده و با استفاده از ویجت <b>دوره</b> میتوانید در کنار معرفی دوره، سوالات متداول و جلسات دوره‌ی حرفه‌ای تری داشته باشید. ضمن اینکه در محیط المنتور میتوانید هر ویجت دلخواهی را اضافه کنید. امکان جلسات دوره در المنتور قابلیت اتصال به فایل‌های دوره در ووکامرس را داراست که امنیت دانلود فایل را همواره برقرار کند.</span></p><p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.</p><p>لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.</p>`,
                    videoCover : "/image/courseImg.webp",
                    schoolGallery :[
                        {
                            img : "/image/teacherImg.webp",
                            name : "شروع فعالیت"
                        },
                    ],
                    schoolCourses :[
                        {
                            url : "/course/254",
                            title : "نصب یونیتی ۶",
                            teacher : "مدائنی",
                            teacherId : "25",
                            duration : "۰۱:۲۰:۰۰",
                            price : 0,
                            cover : "/image/courseImg.webp",
                            discount : 40,
                        }
                    ],
                    isLoading :false,
                    totalPage : 10,
                    address : "تهران - خیابان ولیعصر",
                    phone : "02122556688"
                });
        }, 2000);
    }
    function changePage(newPageNumber){
        if(!teacherCourseSection.current){
            teacherCourseSection.current = document.getElementById("teacherCourseSection");
        }
        teacherCourseSection.current.scrollIntoView();
        searchParam.set("p",newPageNumber);
        setData({...data,isLoading : true});
        window.history.pushState({},"",`${window.location.pathname}?${searchParam}`);
        fetchData();
    }
    return isLoading ? <>
        <section className="flex flexCol container mar20">
            <div className="flex flexCol podcastDetailsRouteLoading rel">
                <div className="loaderItem"></div>
            </div>
            <div className="flex flexCol courseDetailsLoading rel">
                <div className="loaderItem"></div>
            </div>
            <div className="grid courseDetailsLoading2">
                <div className="flex flexCol rel courseDetailsItem1">
                    <div className="loaderItem"></div>
                </div>
                <div className="flex flexCol rel courseDetailsItem2">
                    <div className="loaderItem"></div>
                </div>
            </div>
        </section>
    </> : <>
        <NavsList data={[{name:data.title,link:""}]} />
        <section className="grid schoolInfoSection container">
            <div className={`flex flexCol contentDescDiv rel ${showFullDesc}`}>
                <h2 className="faFont textClr3 textSize12 podcastDescriptionTitle rel">
                    معرفی آموزشگاه
                </h2>
                <div className="flex flexCol contentList faFont content rel">
                    {
                        MyComponent({htmlContent:data.description})
                    }
                </div>
                <button className="showFullDescription flex alignCenter faFont textSize9 textClr3" onClick={()=>setShowFullDesc("full")}>
                    مشاهده بیشتر
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path></svg>
                </button>
            </div>
            <button className="flex flexCol courseFirstLeftDiv rel" onClick={()=>setShowFullVideo(true)}>
                <img src={data.videoCover} alt={data.title} className="courseLeftDivImg" width={"100%"} draggable="false" />
                <svg className="coursePlayIcon" stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M133 440a35.37 35.37 0 0 1-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0 1 35.77.45l247.85 148.36a36 36 0 0 1 0 61l-247.89 148.4A35.5 35.5 0 0 1 133 440z"></path></svg>
            </button>
        </section>
        <section className="flex schoolMiddleDiv container">
            <div className="flex flexCol schoolRightMiddleDiv">
                <div className="flex flexCol teacherGallerySection">
                    <h3 className="faFont textClr3 teacherCourseTitle flex alignCenter textSize12">
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"></path></svg>
                        گالری تصاویر آموزشگاه
                    </h3>
                    <Swiper className="swiper videoSwiper rel"
                        spaceBetween={10}
                        slidesPerView={2}
                        breakpoints={{
                            968:{
                                slidesPerView: 4,
                            },
                            1100:{
                                slidesPerView: 5,
                                spaceBetween : 20
                            },
                        }}
                    >
                        {
                            data.schoolGallery.map((item,index)=>{
                            return <SwiperSlide key={index} onClick={()=>{setShowFullImageSlider(index + 1)}}>
                                <div className="flex flexCol teacherGalleryItemDiv rel">
                                    <img src={item.img} alt={item.name} className="teacherGalleryImg" />
                                    <p className="faFont textSize1 teacherGalleryText">
                                        {
                                            item.name
                                        }
                                    </p>
                                </div>
                        </SwiperSlide>
                        })
                        }
                    </Swiper>
                </div>
                <div className="flex flexCol teacherCourseSection" id="teacherCourseSection">
                    <h3 className="faFont textClr3 teacherCourseTitle flex alignCenter textSize12">
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 640 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"></path></svg>
                        دوره های درس آموزشگاه
                    </h3>
                    <div className="grid teacherCourseGrid">
                        {
                            data.schoolCourses.map((item,index)=>{
                                return <CourseItem data={item} key={index} />
                            })
                        }
                    </div>
                    <PagePagintaion data={{totalNumber:data.totalPage,
                        changePage : changePage, currentPage:pageNumber}} />
                </div>
            </div>
            <div className="flex flexCol schoolLeftMiddleDiv">
                <div className="flex flexCol schoolInfoItem alignCenter">
                    <p className="faFont textSize9 textClr7 schoolInfoTitleText flex alignCenter">
                        <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" round="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                        آدرس :
                    </p>
                    <p className="faFont textSize1 textClr3 schoolInfoDescText">
                       {
                        data.address
                       }
                    </p>
                </div>
                <div className="flex flexCol schoolInfoItem alignCenter">
                    <p className="faFont textSize1 textClr7 schoolInfoTitleText flex alignCenter">
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="#D9D9D9" d="M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 0 1 438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z"></path><path d="M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"></path></svg>
                        تلفن :
                    </p>
                    <a href={`tel:+${data.phone}`} className="faFont textSize11 textClr3 schoolInfoDescText">
                       {
                        data.phone
                       }
                    </a>
                </div>
            </div>
        </section>
        <ImageFullSlider data={{list :data.schoolGallery}} showFullImageSlider={showFullImageSlider} setShowFullImageSlider={setShowFullImageSlider} />
        <FullVideo data={{videoLink : data.videoLink}} showFullVideo={showFullVideo} setShowFullVideo={setShowFullVideo} />
    </>
}